import React, {FC} from 'react';

import {AsyncHandlerOf, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {compareName} from '../../../../../srcCommon/helpers/localeHelpers';
import {AccountAttributeUpdateAction} from '../../../../helpers/models/accountAttributeUpdateHelpers';
import {AccountModel} from '../../../../models/api/accountModel';
import {CrmSyncStatusesEnum} from '../../../../models/api/crmSyncModel';
import {AccountCustomAttribute, CustomAttributeModel} from './accountCustomAttribute';

/*
 * Props.
 */

interface AccountCustomAttributesProps {
  account: AccountModel;
  customAttributes: ReadonlyArray<CustomAttributeModel>;
  crmSyncEditLink?: string;
  crmSyncStatus?: CrmSyncStatusesEnum;
  crmSyncCustomFieldIds: ReadonlyArray<number>;
  shouldDisableActions?: boolean;
  updateAccountAttributeAsync: AsyncHandlerOf<AccountAttributeUpdateAction>;
  updateUnsavedAccount: HandlerOf<AccountAttributeUpdateAction>;
}

/*
 * Component.
 */

export const AccountCustomAttributes: FC<AccountCustomAttributesProps> = (props) => {
  const {
    account,
    customAttributes,
    crmSyncEditLink,
    crmSyncStatus,
    crmSyncCustomFieldIds,
    shouldDisableActions,
    updateAccountAttributeAsync,
    updateUnsavedAccount,
  } = props;
  return (
    <>
      {sortCustomAttributes(customAttributes).map((customAttribute) => (
        <AccountCustomAttribute
          key={customAttribute.customField.id}
          accountId={account.id}
          customAttribute={customAttribute}
          crmSyncEditLink={crmSyncEditLink}
          crmSyncStatus={crmSyncStatus}
          isFieldCrmSyncing={crmSyncCustomFieldIds.includes(customAttribute.customField.id)}
          crmSyncSource={account.externalInfo?.source}
          shouldDisableActions={shouldDisableActions}
          updateAccountAttributeAsync={updateAccountAttributeAsync}
          updateUnsavedAccount={updateUnsavedAccount}
        />
      ))}
    </>
  );
};

/*
 * Helpers.
 */

function sortCustomAttributes(customAttributes: ReadonlyArray<CustomAttributeModel>) {
  // Using slice to make a copy since the parameter is readonly
  return customAttributes.slice().sort((customAttribute1, customAttribute2) => {
    // Put empty values (newly-added attributes that haven't been saved) at the end
    if (customAttribute1.value === '') {
      return 1;
    }
    if (customAttribute2.value === '') {
      return -1;
    }

    return compareName(customAttribute1.customField.name, customAttribute2.customField.name);
  });
}
